import { MAX_PERCENTAGE, MAX_PERCENTAGE_TEXT } from 'data/global';
import { t } from 'i18next';
import { PublishDealRoomValues } from 'models/DealRoom';
import { getShouldHasRevenueShares, shouldShowFrachisorFee } from 'utils';
import validations from 'validations';

export const validate = (
  values: PublishDealRoomValues,
  hasEnterprise: boolean,
) => {
  const {
    revenueShares,
    projectedSalePrice,
    successFeePercentage,
    franchisorFeePercentage,
  } = values;

  const showFranchisorFee = shouldShowFrachisorFee(hasEnterprise);

  const revenueSharesPercentage = revenueShares?.reduce(
    (acc, { percentage }) =>
      !percentage || !+percentage ? acc : acc + +percentage,
    0,
  );

  const revenuePercentageErrors = revenueShares.map((revenue, index) => {
    const percentageValidation = validations.composeValidators(
      validations.greatherThanZero(t('onlyPositiveNumbersAreAllowed')),
      validations.maxNumber(
        t('maxNumber', { max: MAX_PERCENTAGE_TEXT }),
        MAX_PERCENTAGE,
      ),
    );

    const { orderNumber, ...restRevenue } = revenue;

    const requiredErrors = Object.values(restRevenue).filter(Boolean).length
      ? {
          description: validations.required()(restRevenue.description),
          percentage: validations.composeValidators(
            validations.required(),
            percentageValidation,
          )(restRevenue.percentage, values),
        }
      : {};

    if (revenueSharesPercentage <= MAX_PERCENTAGE) return requiredErrors;

    return {
      ...requiredErrors,
      percentage: t('surpassingValue', { value: MAX_PERCENTAGE_TEXT }),
    };
  });

  let franchisorFeePercentageErrors = {};

  if (
    showFranchisorFee &&
    getShouldHasRevenueShares(projectedSalePrice, successFeePercentage)
  ) {
    franchisorFeePercentageErrors = validations.composeValidators(
      validations.required(t('required')),
      validations.greatherThanZeroOrZero(t('onlyPositiveNumbersAreAllowed')),
      validations.maxNumber(
        t('maxNumber', { max: MAX_PERCENTAGE_TEXT }),
        MAX_PERCENTAGE,
      ),
    )(franchisorFeePercentage, values);
  }

  return {
    franchisorFeePercentage: franchisorFeePercentageErrors,
    revenueShares: revenuePercentageErrors,
  };
};
